import { FC } from 'react';
import { Box, Card, CardContent, Skeleton, Typography } from '@mui/material';
import { LineChart, StatisticBento } from '@carcareers/components';

interface StatisticProps {
  title: string;
  data: number[];
  dataLabel: string;
  xAxisLabels: string[];
  secondaryData?: number[];
  secondaryDataLabel?: string;
  previousValue?: number;
  activeValue?: number;
  totalValue?: number;
  isLoading?: boolean;
}

export const Statistic: FC<StatisticProps> = ({
  title,
  data,
  dataLabel,
  xAxisLabels,
  secondaryData,
  secondaryDataLabel,
  previousValue,
  activeValue,
  totalValue,
  isLoading,
}) => {
  return (
    <Card
      elevation={0}
      sx={{
        flex: 1,
        width: { xs: '100%', sm: '48%', md: '32%' },
        minHeight: 300,
        borderRadius: 3,
        border: 0,
      }}
    >
      <CardContent sx={{ height: '100%' }}>
        <Typography variant="h5" sx={{ mb: 2, mx: 1 }}>
          {title}
        </Typography>
        <Box
          sx={{
            display: 'flex',
            flexDirection: 'column',
            position: 'relative',
            justifyContent: 'space-between',
          }}
        >
          <StatisticBento
            allValue={totalValue}
            previousValue={previousValue}
            activeValue={activeValue}
            isLoading={isLoading}
          />
          <Box
            sx={{
              width: '100%',
              height: '100%',
              '& canvas': {
                width: '100% !important',
                height: '100% !important',
              },
            }}
          >
            <LineChart
              data={data}
              dataLabel={dataLabel}
              secondaryData={secondaryData}
              secondaryDataLabel={secondaryDataLabel}
              xAxisLabels={xAxisLabels}
              isLoading={isLoading}
            />
          </Box>
        </Box>
      </CardContent>
    </Card>
  );
};

export default Statistic;
